






















import {Component, Prop, Vue} from "vue-property-decorator";
import Keyword from "@/components/Keyword.vue";
import {MainPageConfig} from "@/interfaces/main-page.interface";

@Component({
  components: {
    Keyword
  }
})
export default class WordCloud extends Vue {
  baseUrl = process.env.VUE_APP_PUBLIC_URL;

  @Prop()
  words: MainPageConfig.IKeyWord[];

  isMobile: boolean = false;

  get staticList() {
    return this.words.slice(0, 11)
  }

  get dynamicList() {
    const list = (this.isMobile) ? this.words.slice(0, 25) : this.words.slice(11, 50);
    return list.map( item => [item])
  }

  created() {
    this.isMobile = window.matchMedia("(max-width: 767px)").matches;
    window.matchMedia("(max-width: 767px)").onchange = (match) => {
      this.isMobile = match.matches;
    }
  }
}
